import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'marketingactions'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'marketingactions', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'marketingactions'),
				action: ({ model, t }) => {
					const { maac_title } = model;
					Utils.openLink({
						pathname: '/marketingactions/add',
						state: {
							model: { ...model, maac_title: maac_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(
						showAddNotesDialog({
							model: { note_table: 'marketingactions', note_table_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: { chro_maac_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: { oppo_maac_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: { cntr_maac_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: { ords_maac_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: { proj_maac_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: { acti_maac_uid: model.maac_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'marketingactions'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'marketingactions',
							id: model.maac_uid,
							title: model.maac_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'marketingactions'),
				action: () => Utils.openLink({ pathname: '/marketingactions/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'marketingactions'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'marketingactions'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'marketingactions',
							id: model.maac_uid,
							title: model.maac_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'marketingactions'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'chronology',
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: { chro_maac_uid: model.maac_uid }
						})
					)
			},
			{
				id: 'opportunities',
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: { oppo_maac_uid: model.maac_uid }
						})
					)
			},
			{
				id: 'contracts',
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: { cntr_maac_uid: model.maac_uid }
						})
					)
			},
			{
				id: 'orders',
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: { ords_maac_uid: model.maac_uid }
						})
					)
			},
			{
				id: 'projects',
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: { proj_maac_uid: model.maac_uid }
						})
					)
			},
			{
				id: 'activities',
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: { acti_maac_uid: model.maac_uid }
						})
					)
			}
		]
	}
};

export default buttons;
